import { v4 as uuidv4 } from 'uuid';

export const onLoadInAuth = (actSetInAuthUUID) => () => {
  const uuid = uuidv4();
  if (window.inauthSetTid) {
    window.inauthSetTid(uuid, 'GAC'); // clientName = GAC
    actSetInAuthUUID(uuid);
  }
};
